import { render, staticRenderFns } from "./UIResultMaxListNumber.vue?vue&type=template&id=0935deea&scoped=true&"
import script from "./UIResultMaxListNumber.vue?vue&type=script&lang=js&"
export * from "./UIResultMaxListNumber.vue?vue&type=script&lang=js&"
import style0 from "./UIResultMaxListNumber.vue?vue&type=style&index=0&id=0935deea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0935deea",
  null
  
)

export default component.exports